let screensize = "";

window.onresize = function() {
	if (window.__resizing) return;
	window.__resizing = true;
	Resize();
	window.__resizing = false;
};

function viewport() {
	let viewportwidth;
	if (typeof window.innerWidth !== 'undefined') {
		viewportwidth = window.innerWidth
	} else if (typeof document.documentElement !== 'undefined' && typeof document.documentElement.clientWidth !== 'undefined' && document.documentElement.clientWidth !== 0) {
		viewportwidth = document.documentElement.clientWidth
	} else {
		viewportwidth = document.getElementsByTagName('body')[0].clientWidth
	}
	return viewportwidth;
}

function sliders() {
	if ($('#main-content #news.home .container .row .col-12').length > 2) {
		if (screensize === "lg" || screensize === "md" || screensize === "sm") {
			$('#main-content #news.home .container .row').not('.slick-initialized').slick({
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 4000,
				speed: 1500,
				arrows: false,
				dots: false,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
						}
					}
				]
			});
		}
		else {
			$('#main-content #news.home .container .row.slick-initialized').slick('unslick');
		}
	}

	if ($('#main-content #companies.home .company-item').length > 1) {
		if (screensize === "sm") {
			$('#main-content #companies.home').not('.slick-initialized').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 4000,
				speed: 1500,
				arrows: false,
				dots: false
			});
		}
		else {
			$('#main-content #companies.home.slick-initialized').slick('unslick');
		}
	}
}

function Resize() {
	if ((viewport() >= 1200) && screensize !== "xl") {
		screensize = "xl";
		sliders();
	} else if ((viewport() >= 992) && (viewport() < 1200) && screensize !== "lg") {
		screensize = "lg";
		sliders();
	} else if ((viewport() >= 768) && (viewport() < 992) && screensize !== "md") {
		screensize = "md";
		sliders();
	} else if ((viewport() < 768) && screensize !== "sm") {
		screensize = "sm";
		sliders();
	}
}

function menu() {
	$("#menu-button").click(function() {
		if($('#menu').hasClass('show')) {
			$('#menu').removeClass('show');
			$('#menu-button').removeClass('menu-open');
		} else {
			$('#menu').addClass('show');
			$('#menu-button').addClass('menu-open');
		}
	});

	$("#menu-button-mobile").click(function() {
		if ($('#menu-mobile').hasClass('show')) {
			$('#menu-mobile').removeClass('show');
			$('#menu-button-mobile').removeClass('menu-open');
		} else {
			$('#menu-mobile').addClass('show');
			$('#menu-button-mobile').addClass('menu-open');
		}
	});
}

$(document).ready(function() {
	let $header = $('#main-header');

	$('#scrolldown').off('click').on('click', function() {
		let scrollHeight = $header.height();
		$('html, body').animate({
			scrollTop: scrollHeight
		}, 1000);
	});

	let input = document.getElementById("search");
	input.addEventListener("keyup", function(event) {
		if (event.keyCode === 13) {
			event.preventDefault();
			document.getElementById("searchButton").click();
		}
	});

	let inputmobile = document.getElementById("searchMobile");
	inputmobile.addEventListener("keyup", function(event) {
		if (event.keyCode === 13) {
			event.preventDefault();
			document.getElementById("searchButtonMobile").click();
		}
	});

	$('.search-open').click(function(){
		setTimeout(function(){
			document.getElementById("search").focus();
		}, 100);
		setTimeout(function(){
			document.getElementById("searchMobile").focus();
		}, 100);
	});

	menu();
	Resize();
});

